import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import { type } from '@utiljs/type';
import { isFunction } from '@utiljs/is';
import createRef from '@roo/create-react-ref/createRef';

var Affix = /*#__PURE__*/function (_React$Component) {
  _inherits(Affix, _React$Component);

  var _super = _createSuper(Affix);

  function Affix(props) {
    var _this;

    _classCallCheck(this, Affix);

    _this = _super.call(this, props);
    _this.affixRef = createRef();
    _this.affixChildrenRef = createRef();

    _this.getContainer = function () {
      var container = _this.props.container;
      var contain = type(container) === 'function' ? container() : container; // eslint-disable-next-line

      return ReactDOM.findDOMNode(contain) || container;
    };

    _this.getContain = function () {
      var container = _this.props.container;
      var contain = container ? _this.getContainer() : window;
      return contain;
    };

    _this.on = function (node, eventName, callback) {
      if (node.addEventListener) {
        node.addEventListener(eventName, callback, false);
      }
    };

    _this.off = function (node, eventName, callback) {
      if (node.removeEventListener) {
        node.removeEventListener(eventName, callback, false);
      }
    };

    _this.getScrollTop = function (node, isVertical) {
      var windowProp = isVertical ? 'pageYOffset' : 'pageXOffset';
      var elementProp = isVertical ? 'scrollTop' : 'scrollLeft';
      return (type(node) === 'window' || type(node) === 'global' ? node[windowProp] : node[elementProp]) || 0;
    };

    _this.getClientRect = function (node) {
      var rect = {
        top: 0,
        left: 0,
        bottom: 0
      };
      if (type(node) !== 'window' && type(node) !== 'global') rect = node.getBoundingClientRect();
      return rect;
    };

    _this.getNodeOffset = function (affixNode, affixContainer) {
      var affixRect = affixNode.getBoundingClientRect(); // affix children 相对浏览器窗口的位置

      var containerRect = _this.getClientRect(affixContainer); // affix 外部容器容器 相对浏览器窗口的位置


      var containerScrollTop = _this.getScrollTop(affixContainer, true);

      var containerScrollLeft = _this.getScrollTop(affixContainer, false);

      return {
        top: affixRect.top - containerRect.top + containerScrollTop,
        left: affixRect.left - containerRect.left + containerScrollLeft,
        width: affixRect.width,
        height: affixRect.height
      };
    };

    _this.getNodeHeight = function (node) {
      if (!node) {
        return 0;
      }

      if (type(node) === 'window' || type(node) === 'global') {
        return window.innerHeight;
      }

      return node.clientHeight;
    };

    _this.resizePosition = function () {
      var contain = _this.getContain();

      var _this$props = _this.props,
          offsetTop = _this$props.offsetTop,
          offsetBottom = _this$props.offsetBottom,
          onAffix = _this$props.onAffix;

      var containerScrollTop = _this.getScrollTop(contain, true); // 容器在垂直位置上的滚动 offset


      var affixOffset = _this.getNodeOffset(_this.affixRef.current, contain); // 目标节点当前相对于容器的 offset


      var containerHeight = _this.getNodeHeight(contain); // 容器的高度


      var affixHeight = _this.affixRef.current.offsetHeight;

      var containerClientRect = _this.getClientRect(contain);

      var style = {
        width: affixOffset.width
      };
      var containerStyle = {
        width: affixOffset.width,
        height: _this.affixChildrenRef.current.offsetHeight
      };
      var startAffix = false;

      if (type(offsetTop) === 'number' && containerScrollTop > affixOffset.top - offsetTop) {
        //当传入的为offsetTop时，并且距离顶部的位置大于offsetTop时
        style.position = 'fixed';
        style.top = offsetTop + containerClientRect.top; // eslint-disable-line

        startAffix = true;
        if (isFunction(onAffix)) onAffix(true);
      } else if (type(offsetBottom) === 'number' && containerScrollTop > affixOffset.top + affixHeight + offsetBottom - containerHeight) {
        // eslint-disable-line
        //当传入的为offsetBottom时，并且距离底部的位置小于offsetBottom时
        style.position = 'fixed';
        style.bottom = offsetBottom;
        startAffix = true;
        if (isFunction(onAffix)) onAffix(true);
      } else {
        startAffix = false;
        if (isFunction(onAffix)) onAffix(false);
      }

      _this.setState({
        style: style,
        containerStyle: containerStyle,
        startAffix: startAffix
      });
    };

    _this.state = {
      startAffix: false,
      style: {},
      containerStyle: {}
    };
    return _this;
  }

  _createClass(Affix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var contain = this.getContain();
      this.on(contain, 'scroll', this.resizePosition);
      window.addEventListener('resize', this.resizePosition, false);
      this.resizePosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var contain = this.getContain();
      this.off(contain, 'scroll', this.resizePosition);
      window.removeEventListener('resize', this.resizePosition);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          zIndex = _this$props2.zIndex,
          customStyle = _this$props2.style,
          className = _this$props2.className;
      var _this$state = this.state,
          style = _this$state.style,
          containerStyle = _this$state.containerStyle,
          startAffix = _this$state.startAffix;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.affixRef,
        className: className,
        style: customStyle
      }, startAffix && /*#__PURE__*/React.createElement("div", {
        style: containerStyle
      }), /*#__PURE__*/React.createElement("div", {
        ref: this.affixChildrenRef,
        style: _Object$assign(_Object$assign({}, style), {
          zIndex: zIndex
        })
      }, children));
    }
  }]);

  return Affix;
}(React.Component);

Affix.propTypes = {
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  offsetTop: PropTypes.number,
  offsetBottom: PropTypes.number,
  onAffix: PropTypes.func,
  zIndex: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
};
Affix.defaultProps = {
  className: '',
  style: {},
  zIndex: 1000,
  offsetTop: null,
  offsetBottom: null,
  onAffix: function onAffix() {}
};
export default Affix;